import { render, staticRenderFns } from "./matrix.vue?vue&type=template&id=01cbc45e"
import script from "./matrix.vue?vue&type=script&lang=js"
export * from "./matrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports